export const AUTH_SET_AUTHENTICATED = 'AUTH_SET_AUTHENTICATED';
export const AUTH_SET_STUDENT_INFO = 'AUTH_SET_STUDENT_INFO';
export const AUTH_LOGIN_START = 'AUTH_LOGIN_START';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGOUT_START = 'AUTH_LOGOUT_START';
export const AUTH_LOGOUT_FAILURE = 'AUTH_LOGOUT_FAILURE';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
export const AUTH_WHOAMI = 'AUTH_WHOAMI';
export const AUTH_WHOAMI_SUCCESS = 'AUTH_WHOAMI_SUCCESS';
export const AUTH_WHOAMI_FAILURE = 'AUTH_WHOAMI_FAILURE';
